import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import React, { useState } from "react";

import FormAction from "../../../../components/common/FormAction";
import MultiSelect from "../../../../components/common/MultiSelect";
import { salutation } from "../../../../utils/tenants";
import { tags } from "../../Tenants/TenantDetails/data";
import { vendorTrade, vendorType } from "../../Vendors/vendersData";
import { db } from "../../../../firebase";
import { collection, doc, setDoc, updateDoc } from "firebase/firestore";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

function PersonalInformation({
  data,
  peopleType,
  renderData,
  companyName,
  collectionName,
  id,
}) {
  const [checked, setChecked] = useState(false);
  // const { id } = useParams();

  // const [form] = Form.useForm();

  //console.log("DataBase Data===>", data)

  const onCancel = () => {
    setChecked(false);
  };

  console.log("id..........", id)
  console.log("collectionName", collectionName);
  console.log("companyName", companyName);
  const onFinish = (values) => {
    //  console.log("Success:", values);
    // form.setFieldsValue(values);
    // const companiesRef = collection(db, "companies");
    // const companyDocRef = doc(companiesRef, companyName);
    // const ownerRef = collection(companyDocRef, collectionName);

    const ref = doc(db, "companies", companyName, collectionName, id);   

    let vendorInfo = {};

    if (collectionName === "vendors") {
      vendorInfo = {
        "vendorInfo": {
          salutation: values.salutation,
          firstName: values.firstName,
          lastName: values.lastName,
          companyName: values.companyName,
          // useCompanyName: values.useCompanyName,
          // websiteLink: values.websiteLink,
          // vendorType: values.vendorType,
          // venderTrade: values.venderTrade,
          // tags: values.tags,
          // send1099: values.send1099,
          // vendorWorkOrder: values.vendorWorkOrder,
        },
      };
    }

    console.log("vendorInfo........", vendorInfo);

    try {
      updateDoc(ref, vendorInfo);
      message.success("owner Information updated successfully...");
      setChecked(false);
      renderData(true);
    } catch (err) {
      console.error(err);
      message.success("Something went wrong!");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const defaultValues = {
    salutation: data?.salutation ? data?.salutation : "",
    firstName: data?.firstName ? data?.firstName : "",
    lastName: data?.lastName ? data?.lastName : "",
    companyName: data?.companyName ? data?.companyName : "",
    useCompanyName: data?.useCompanyName ? data?.useCompanyName : "",
    websiteLink: data?.websiteLink ? data?.websiteLink : "",
    vendorType: data?.vendorType ? data?.vendorType : "",
    venderTrade: data?.venderTrade ? data?.venderTrade : "",
    tags: data?.tags ? data?.tags : "",
    send1099: data?.send1099 ? data?.send1099 : "",
    vendorWorkOrder: data?.vendorWorkOrder ? data?.vendorWorkOrder : "",
  };
  return (
    <Card
      title={
        checked ? (
          `${peopleType}   Information`
        ) : (
          <p>
            Mr.{" "}
            {data?.firstName && data?.lastName ? (
              data?.firstName + " " + data?.lastName
            ) : (
              <p> {data?.companyName ? data?.companyName : " "}</p>
            )}
          </p>
        )
      }
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <div>
          <Form
            name="basic"
            colon={false}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 11 }}
            labelWrap={{ span: 8 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={defaultValues}
          >
            <Col span={24}>
              <Form.Item label="Salutation" name="salutation">
                <Select options={salutation} />
              </Form.Item>
              <Form.Item
                label="First Name"
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Field is required!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Last Name"
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "Field is required!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item label="Company Name" name="companyName">
                <Input />
              </Form.Item>

              <Form.Item
                label="Use company name as display name"
                name="useCompanyName"
                valuePropName="checked"
              >
                <Checkbox></Checkbox>
              </Form.Item>
              {peopleType === "Vendor" ? (
                <>
                  <Form.Item label=" " name="acceptWorkOrders">
                    <Checkbox>Do not have vendor accept work orders</Checkbox>
                  </Form.Item>
                  <Form.Item name="websiteLink" label="Website">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Salutation">
                    <Select
                      options={vendorType}
                      placeholder="Select..."
                      showSearch
                      allowClear
                    />
                  </Form.Item>
                  <Form.Item label="Salutation">
                    <MultiSelect
                      options={vendorTrade}
                      placeholder="Select..."
                    />
                  </Form.Item>
                </>
              ) : null}

              <Form.Item label="Tags" name="tags">
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  tokenSeparators={[","]}
                  options={
                    data?.tags
                      ? data.tags.map((tag) => ({
                          label: tag,
                          value: tag,
                        }))
                      : []
                  }
                />
              </Form.Item>

              {peopleType === "Vendor" ? (
                <Form.Item label=" ">
                  <Checkbox>Do Not Use Vendor for Work Orders</Checkbox>
                </Form.Item>
              ) : null}

              <Form.Item label="    ">
                <Link
                  to="/generalsettings/manage-tags"
                  className="onclick-text"
                >
                  Manage tags
                </Link>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Row gutter={[8, 0]}>
                <Col>
                  <Button type="primary" htmlType="submit">
                    Save
                  </Button>
                </Col>
                <Col>
                  <Button onClick={() => setChecked(false)}>Cancel</Button>
                </Col>
              </Row>
            </Col>
          </Form>
        </div>
      ) : (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
        >
          {
            // peopleType === "Vendor" ? (
            <>
              {" "}
              <Form.Item label="Salutation">
                <p>{data?.salutation}</p>
              </Form.Item>
              <Form.Item label="First Name" required>
                <p>{data?.firstName ? data?.firstName : ""}</p>
              </Form.Item>
              <Form.Item label="Last Name" required>
                <p>{data?.lastName ? data?.lastName : ""}</p>
              </Form.Item>
              <Form.Item label="Company Name">
                <p>{data?.companyName ? data?.companyName : ""}</p>
              </Form.Item>
            </>

            // ) : null
          }

          <Form.Item
            label="Tags"
          >
            <Row gutter={[4, 0]} className="tags">
              {/* {data?.company ? (
                data?.company
              ) : ( */}
                <p>
                  {data?.tags && data.tags.length > 0
                    ? data.tags.map((item, index) => {
                        return (
                          <Col key={index}>
                            <span className="tag">{item}</span>
                          </Col>
                        );
                      })
                    : " "}
                </p>
              {/* )} */}
            </Row>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
}

export default PersonalInformation;
